<div class="broker-plan-payment-failed position-relative pad-32-bottom">
    <div class="position-absolute  cursor-pointer close-button" (click)="closeDialog()">
        <mat-icon>close</mat-icon>
    </div>
    <div class="avatar-renewal flex-centered-container">
        <img src="/assets/icons/logo-compact.png">
    </div>
    <div class="flex-centered-container margin-8-bottom">
        <mat-icon class="text-accent margin-4-right">
            check_circle_filled
        </mat-icon>
        <h2 class="font-18">
            Subscription renewed
        </h2>
    </div>
    <div class="font-14 margin-auto text-center policies-text padding-bottom margin-8-bottom">
        Your autopayment was successful.
    </div>
    <mat-divider class="mat-divider width-90 margin-auto"></mat-divider>
    <div class="padding-hr width-70 margin-auto padding-top">
        <div class="font-14 flex-space-between margin-8-bottom">
            <span class="policies-text">Plan</span>
            <span>{{currentPlanName}}</span>
        </div>
        <div class="font-14 flex-space-between margin-8-bottom">
            <span class="policies-text">Valid till</span>
            <span>{{activePlanValidity}}</span>
        </div>
    </div>
    <div class="text-center padding-top">
        <a class="text-accent font-14 cursor-pointer" (click)="routeToTransaction()"><span class="decoration-underline">
                Check Transaction History</span>
            ></a>
    </div>
</div>